@let notificationValue = notification();
@let hasAccessToNotificationsModifyValue = hasAccessToNotificationsModify();

<div class="notification">
  <div class="notification__checkbox">
    <button
      type="button"
      class="notification__checkbox-wrapper"
      [class.notification__checkbox-wrapper--disabled]="!hasAccessToNotificationsModifyValue"
      [attr.aria-label]="toggleViewabilityLabelKey() | translate"
      [attr.aria-disabled]="!hasAccessToNotificationsModifyValue || null"
      [kdsTooltip]="'general.missing-permission' | translate"
      [disableTooltip]="hasAccessToNotificationsModifyValue"
      (click)="toggleNotificationViewability()"
    >
      @if (!notificationValue.viewed) {
        <span class="notification__checkbox-wrapper-indicator"></span>
      }
    </button>
  </div>
  @if (zendeskTicketId()) {
    <button type="button" class="notification__content notification__content--clickable" (click)="openNotification()">
      <ng-template *ngTemplateOutlet="notificationContent" />
    </button>
  } @else {
    <div class="notification__content">
      <ng-template *ngTemplateOutlet="notificationContent" />
    </div>
  }
  <button
    type="button"
    class="notification__delete"
    [class.notification__delete--disabled]="!hasAccessToNotificationsModifyValue"
    [attr.aria-label]="'notifications.delete' | translate"
    [attr.aria-disabled]="!hasAccessToNotificationsModifyValue || null"
    [kdsTooltip]="'general.missing-permission' | translate"
    [disableTooltip]="hasAccessToNotificationsModifyValue"
    (click)="deleteNotification()"
  >
    <i aria-hidden="true" class="notification__delete-icon fa-regular fa-xmark"></i>
  </button>
</div>

<ng-template #notificationContent>
  <span class="notification__content-header">
    {{ notificationTitle$ | async }}
  </span>
  <span class="notification__content-body">
    {{ notificationContent$ | async }}
  </span>
  <span class="notification__content-footer">
    {{ formatDate(notificationValue.dateTimeOfOccurrence, { format: 'mediumDate' }) }}
  </span>
</ng-template>
